import React from 'react';
import PropTypes from 'prop-types';

const warnedStates = new Set();

function normalizeReviewState(state) {
  if (state === 'review_pending' || state === 'signed_off' || state === 'open') {
    return state;
  }

  if (state && !warnedStates.has(state)) {
    warnedStates.add(state);
    // eslint-disable-next-line no-console
    console.warn('[chemkit] Unexpected reaction review state', state);
  }

  return 'open';
}

function labelForState(state) {
  if (state === 'review_pending') {
    return 'Review pending';
  }
  if (state === 'signed_off') {
    return 'Accepted';
  }
  return null;
}

export default function ReactionReviewPill({ element }) {
  const state = normalizeReviewState(element?.chemkit?.review?.state);
  const label = labelForState(state);
  if (!label) {
    return null;
  }

  return (
    <span className="badge rounded-pill bg-info text-dark" title={`Review state: ${state}`}>
      {label}
    </span>
  );
}

ReactionReviewPill.propTypes = {
  element: PropTypes.shape({
    id: PropTypes.number,
    chemkit: PropTypes.shape({
      version: PropTypes.number,
      review: PropTypes.shape({
        state: PropTypes.string,
        is_locked: PropTypes.bool,
      }),
    }),
  }).isRequired,
};
